import React from 'react';
import { connect } from 'react-redux';
import { isEmpty, omit } from 'lodash';
import { confirmation } from 'redux-form-validators';

import { sendPasswordUpdateRequest, reset } from '../../../../services/account/password/actions';

import { FormComponent, PasswordInputFieldComponent, LegendFieldComponent } from '../../../form';

import './ProfileFormComponent.scss';

const FORM_NAME = 'update-password-form';

const CONFIRMATIONS_FIELD_NAME = ['passwordconfirm'];

class UpdatePasswordFormComponent extends React.Component {
    submit = values => {
        const { sendPasswordUpdateRequest, reset } = this.props;

        sendPasswordUpdateRequest(omit(values, CONFIRMATIONS_FIELD_NAME), () => {
            setTimeout(() => {
                reset();
            }, 3000);
        });
    };

    render() {
        const {
            i18n,
            i18nForm,
            errorMessage,
            requestSubmit,
            errorSubmit,
            successSubmit
        } = this.props;

        return (
            <FormComponent
                form={FORM_NAME}
                classNameInputContainer="grid-3 has-gutter"
                onSubmit={this.submit}
                requestSubmit={requestSubmit}
                errorSubmit={errorSubmit}
                submitText={i18n.BUTTON_VALIDATE_PASSWORD}>
                <PasswordInputFieldComponent
                    name="oldPassword"
                    classNameInputContainer="one-half mr50"
                    placeholder={i18n.LABEL_OLD_PASSWORD}
                    label={i18n.LABEL_OLD_PASSWORD}
                    noDefaultValidation
                    isRequired
                />
                <PasswordInputFieldComponent
                    name="newPassword"
                    classNameInputContainer="one-half"
                    placeholder={i18n.LABEL_NEW_PASSWORD}
                    label={i18n.LABEL_NEW_PASSWORD}
                    isRequired
                />
                <PasswordInputFieldComponent
                    name="passwordconfirm"
                    classNameInputContainer="one-half"
                    placeholder={i18n.LABEL_CONFIRM_NEW_PASSWORD}
                    label={i18n.LABEL_CONFIRM_NEW_PASSWORD}
                    isRequired
                    validate={[
                        confirmation({
                            field: 'newPassword',
                            msg: i18nForm.PASSWORD_CONFIRM_ERROR
                        })
                    ]}
                />
                <LegendFieldComponent classNameInputContainer="full txtright">
                    {i18nForm.TEXT_REQUIRED_FIELD}
                </LegendFieldComponent>
                {errorMessage && (
                    <LegendFieldComponent classNameInputContainer="color-err message full">
                        {errorMessage}
                    </LegendFieldComponent>
                )}
                {successSubmit && (
                    <LegendFieldComponent classNameInputContainer="color-succ form-success-message message full">
                        {i18n.PASSWORD_SUBMIT_SUCCEEDED}
                    </LegendFieldComponent>
                )}
            </FormComponent>
        );
    }
}

function mapStateToProps(state) {
    return {
        i18nForm: state.i18n.feature.form,
        i18n: state.i18n.page.ACCOUNT.PROFILE,
        isAuthed: !isEmpty(state.authentication.token),
        errorMessage: state.account.password.error,
        requestSubmit: state.account.password.fetching,
        errorSubmit: !isEmpty(state.account.password.error),
        successSubmit: state.account.password.successPasswordUpdate
    };
}

const mapDispatchtoProps = {
    sendPasswordUpdateRequest,
    reset
};

export default connect(mapStateToProps, mapDispatchtoProps)(UpdatePasswordFormComponent);



// WEBPACK FOOTER //
// ./src/components/pages/account/myprofile/UpdatePasswordFormComponent.js